import { IValidationFormContacts } from './interfaces';

export const ValidationFormContacts = ({
  phone,
  msg,
  setErrorPhone,
  setErrorMsg,
}: IValidationFormContacts) => {
  let err = 0;

  if (msg.length === 0) {
    setErrorMsg('Пожалуйста, заполните поле');
    err = 1;
  } else {
    setErrorMsg(null);
  }

  if (phone === '+7 (___) ___-__-__' || phone.replace(/[^0-9]/g, '').length < 11) {
    setErrorPhone('Пожалуйста, заполните поле');
    err = 1;
  } else {
    setErrorPhone(null);
  }

  if (err) {
    return false;
  }

  return true;
};
